import React, { useEffect, useState } from 'react';

import JackpotCoinImg from '../../../assets/images/jackpot/jackpot_coin.png';
import JackpotCoinImg1 from '../../../assets/images/jackpot/jackpot_coin1.png';

import './style.scss';

const DEFAULT_COLOR_MATRIX = '--brand-col-1';

const getBrandColorMatrix = (mode) => {
  const className = mode === 'cashier' ? 'cashier-app' : 'terminal-wrapper';
  const element = document.getElementsByClassName(className)[0];

  if (!element) {
    return DEFAULT_COLOR_MATRIX;
  }

  const style = getComputedStyle(element);
  const rgbString = style.getPropertyValue('--brand-col-1')?.trim();

  const [r, g, b] = rgbString.split(',').map((val) => parseInt(val.trim(), 10));
  const a = 0.16;

  const rNorm = r / 255;
  const gNorm = g / 255;
  const bNorm = b / 255;

  return [
    `0 0 0 0 ${rNorm}`,
    `0 0 0 0 ${gNorm}`,
    `0 0 0 0 ${bNorm}`,
    `0 0 0 ${a} 0`,
  ].join(' ');
};

const JackpotCardBackground = ({ theme, mode }) => {
  const [colorMatrix, setColorMatrix] = useState('');

  useEffect(() => {
    const newMatrix = getBrandColorMatrix(mode);
    setColorMatrix(newMatrix);
  }, [theme]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="420" height="96" viewBox="0 0 420 96" fill="none">
      <g filter="url(#filter0_ii_2022_2898)">
        <g clipPath="url(#clip0_2022_2898)">
          <rect width="420" height="96" rx="8" fill="#1A1A1A" />
          <path d="M366.912 51.0932L367.169 51.2261L367.341 50.9826L367.362 51.2866L367.646 51.3237L367.41 51.4949L367.521 51.7754L367.264 51.6426L367.092 51.8861L367.071 51.5821L366.787 51.545L367.024 51.3738L366.912 51.0932Z" fill="#6F6C7D" />
          <path d="M196.937 74.812L197.195 74.9448L197.367 74.7013L197.388 75.0053L197.672 75.0424L197.435 75.2136L197.547 75.4942L197.289 75.3614L197.117 75.6049L197.096 75.3008L196.812 75.2638L197.049 75.0926L196.937 74.812Z" fill="#6F6C7D" />
          <path d="M61.0252 29.1704L61.2826 29.3032L61.4547 29.0597L61.4755 29.3637L61.7595 29.4008L61.5228 29.572L61.6346 29.8526L61.3771 29.7198L61.2051 29.9633L61.1843 29.6592L60.9003 29.6222L61.137 29.451L61.0252 29.1704Z" fill="#6F6C7D" />
          <path d="M5.37868 42.4673L5.63615 42.6001L5.80825 42.3566L5.82905 42.6606L6.11298 42.6977L5.8763 42.8689L5.98814 43.1495L5.73066 43.0166L5.55857 43.2601L5.53777 42.9561L5.25384 42.919L5.49051 42.7478L5.37868 42.4673Z" fill="#6F6C7D" />
          <path d="M348.363 70.8589L348.621 70.9917L348.793 70.7482L348.813 71.0522L349.097 71.0893L348.861 71.2605L348.973 71.5411L348.715 71.4082L348.543 71.6517L348.522 71.3477L348.238 71.3106L348.475 71.1394L348.363 70.8589Z" fill="#6F6C7D" />
          <path d="M418.511 64.0307L418.769 64.1636L418.941 63.9201L418.962 64.2241L419.246 64.2612L419.009 64.4324L419.121 64.7129L418.863 64.5801L418.691 64.8236L418.671 64.5196L418.387 64.4825L418.623 64.3113L418.511 64.0307Z" fill="white" />
          <path d="M368.261 11.2016L368.519 11.3345L368.691 11.091L368.712 11.395L368.996 11.4321L368.759 11.6033L368.871 11.8838L368.613 11.751L368.441 11.9945L368.421 11.6905L368.137 11.6534L368.373 11.4822L368.261 11.2016Z" fill="white" />
          <path d="M269.783 51.4526L270.04 51.5854L270.213 51.3419L270.233 51.646L270.517 51.683L270.281 51.8542L270.392 52.1348L270.135 52.002L269.963 52.2455L269.942 51.9415L269.658 51.9044L269.895 51.7332L269.783 51.4526Z" fill="white" />
          <path d="M131.511 50.7339L131.769 50.8667L131.941 50.6232L131.962 50.9272L132.246 50.9643L132.009 51.1355L132.121 51.4161L131.863 51.2832L131.691 51.5267L131.671 51.2227L131.387 51.1856L131.623 51.0144L131.511 50.7339Z" fill="white" />
          <g filter="url(#filter1_f_2022_2898)">
            <path d="M305.869 24.1391L306.126 24.272L306.298 24.0285L306.319 24.3325L306.603 24.3696L306.367 24.5408L306.478 24.8213L306.221 24.6885L306.049 24.932L306.028 24.628L305.744 24.5909L305.981 24.4197L305.869 24.1391Z" fill="white" />
          </g>
          <g filter="url(#filter2_f_2022_2898)">
            <path d="M166.248 82.0005L166.505 82.1333L166.677 81.8898L166.698 82.1938L166.982 82.2309L166.745 82.4021L166.857 82.6827L166.6 82.5498L166.428 82.7933L166.407 82.4893L166.123 82.4522L166.36 82.281L166.248 82.0005Z" fill="white" />
          </g>
          <g filter="url(#filter3_f_2022_2898)">
            <path d="M181.086 29.8891L181.343 30.022L181.515 29.7785L181.536 30.0825L181.82 30.1196L181.583 30.2908L181.695 30.5713L181.438 30.4385L181.266 30.682L181.245 30.378L180.961 30.3409L181.198 30.1697L181.086 29.8891Z" fill="white" />
          </g>
          <g filter="url(#filter4_f_2022_2898)">
            <path d="M140.292 3.24735L141.082 3.65464L141.609 2.90795L141.673 3.84026L142.544 3.95395L141.818 4.47897L142.161 5.33935L141.372 4.93206L140.844 5.67875L140.78 4.74644L139.909 4.63275L140.635 4.10773L140.292 3.24735Z" fill="#868592" />
          </g>
          <g filter="url(#filter5_f_2022_2898)">
            <path d="M73.1535 72.9681L73.943 73.3753L74.4708 72.6287L74.5346 73.561L75.4052 73.6747L74.6795 74.1997L75.0224 75.0601L74.2328 74.6528L73.7051 75.3995L73.6413 74.4671L72.7706 74.3535L73.4964 73.8284L73.1535 72.9681Z" fill="#6E6B7C" />
          </g>
          <g filter="url(#filter6_f_2022_2898)">
            <path d="M28.2999 43.139L29.0895 43.5462L29.6172 42.7996L29.681 43.7319L30.5517 43.8456L29.826 44.3706L30.1689 45.231L29.3793 44.8237L28.8516 45.5703L28.7878 44.638L27.9171 44.5244L28.6429 43.9993L28.2999 43.139Z" fill="white" />
          </g>
          <g filter="url(#filter7_f_2022_2898)">
            <path d="M244.14 84.1077L244.929 84.515L245.457 83.7683L245.521 84.7006L246.392 84.8143L245.666 85.3393L246.009 86.1997L245.219 85.7924L244.691 86.5391L244.628 85.6068L243.757 85.4931L244.483 84.9681L244.14 84.1077Z" fill="#868592" />
          </g>
          <g filter="url(#filter8_f_2022_2898)">
            <path d="M417.15 12.5911L417.939 12.9984L418.467 12.2517L418.531 13.184L419.401 13.2977L418.676 13.8227L419.019 14.6831L418.229 14.2758L417.701 15.0225L417.637 14.0902L416.767 13.9765L417.492 13.4515L417.15 12.5911Z" fill="white" />
          </g>
          <g filter="url(#filter9_f_2022_2898)">
            <path d="M351.722 22.6536L352.511 23.0609L353.039 22.3142L353.103 23.2465L353.974 23.3602L353.248 23.8852L353.591 24.7456L352.801 24.3383L352.273 25.085L352.21 24.1527L351.339 24.039L352.065 23.514L351.722 22.6536Z" fill="#6E6B7C" />
          </g>
          <g filter="url(#filter10_f_2022_2898)">
            <path d="M278.538 3.9661L279.328 4.37339L279.856 3.6267L279.919 4.55901L280.79 4.6727L280.064 5.19772L280.407 6.0581L279.618 5.65081L279.09 6.3975L279.026 5.46519L278.155 5.3515L278.881 4.82648L278.538 3.9661Z" fill="white" />
          </g>
          <g opacity="0.8" filter="url(#filter11_f_2022_2898)">
            <circle r="50" fill="rgba(var(--brand-col-1), 1)" />
          </g>
          <g opacity="0.8" filter="url(#filter12_f_2022_2898)">
            <circle cx="420" cy="48" r="50" fill="rgba(var(--brand-col-1), 1)" />
          </g>

          <rect x="274" y="66.1387" width="123.117" height="120" transform="rotate(-40 274 66.1387)" fill="url(#pattern0_2022_2898)" />
          <rect x="78.6973" y="-11" width="60" height="60" transform="rotate(50 78.6973 -11)" fill="url(#pattern1_2022_2898)" />
          <g filter="url(#filter14_f_2022_2898)">
            <rect x="38.8672" y="78.1152" width="30" height="30" transform="rotate(-50 38.8672 78.1152)" fill="url(#pattern2_2022_2898)" />
          </g>
        </g>
        <rect x="0.5" y="0.5" width="419" height="95" rx="7.5" stroke="rgba(var(--brand-col-1), 1)" strokeOpacity="0.16" />
      </g>
      <defs>
        <filter id="filter0_ii_2022_2898" x="0" y="-8" width="420" height="112" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-8" />
          <feGaussianBlur stdDeviation="25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values={colorMatrix} />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2022_2898" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values={colorMatrix} />
          <feBlend mode="normal" in2="effect1_innerShadow_2022_2898" result="effect2_innerShadow_2022_2898" />
        </filter>
        <filter id="filter1_f_2022_2898" x="305.423" y="23.7074" width="1.50113" height="1.54508" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter2_f_2022_2898" x="165.802" y="81.5688" width="1.50113" height="1.54508" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter3_f_2022_2898" x="180.64" y="29.4574" width="1.50113" height="1.54508" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter4_f_2022_2898" x="139.589" y="2.58732" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter5_f_2022_2898" x="72.4506" y="72.308" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter6_f_2022_2898" x="27.5971" y="42.4789" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter7_f_2022_2898" x="243.437" y="83.4477" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter8_f_2022_2898" x="416.447" y="11.9311" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter9_f_2022_2898" x="351.019" y="21.9936" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter10_f_2022_2898" x="277.835" y="3.30607" width="3.27457" height="3.41227" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.16044" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter11_f_2022_2898" x="-110" y="-110" width="220" height="220" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter12_f_2022_2898" x="310" y="-62" width="220" height="220" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <filter id="filter13_d_2022_2898" x="115" y="42.5" width="190" height="37" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2022_2898" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2022_2898" result="shape" />
        </filter>
        <pattern id="pattern0_2022_2898" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2022_2898" transform="scale(0.000976562)" />
        </pattern>
        <pattern id="pattern1_2022_2898" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image1_2022_2898" transform="matrix(0.000989633 0 0 0.000977517 -0.0133844 0)" />
        </pattern>
        <filter id="filter14_f_2022_2898" x="37.8672" y="54.1338" width="44.2656" height="44.2646" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_2022_2898" />
        </filter>
        <pattern id="pattern2_2022_2898" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2022_2898" transform="scale(0.000976562)" />
        </pattern>
        <clipPath id="clip0_2022_2898">
          <rect width="420" height="96" rx="8" fill="white" />
        </clipPath>
        <image id="image0_2022_2898" width="1024" height="930" preserveAspectRatio="none" href={JackpotCoinImg} />
        <image id="image1_2022_2898" width="1024" height="1023" preserveAspectRatio="none" href={JackpotCoinImg1} />
      </defs>
    </svg>
  );
};

export default JackpotCardBackground;
